<template>
  <v-layout
      row
      :style="maxWidth"
  >
    <v-flex
        class="ml-3"
        :style="maxWidth"
    >
      <v-snackbar
          v-model="success"
          color="success"
          :timeout="5000"
          top
      >
        We have e-mailed your password reset link!
      </v-snackbar>
      <v-snackbar
          v-model="error"
          color="error"
          :timeout="5000"
          top
      >
        {{ error_msg }}
      </v-snackbar>
      <breadcrumbs
          :items="breadcrumbsItems"
      ></breadcrumbs>
      <v-card
          class="ma-3 col-sm-6"
          outlined
      >
        <v-card-title>Edit Admin</v-card-title>
        <v-col>
          <v-form
              ref="form"
              v-model="valid"
              lazy-validation
          >
            <v-autocomplete
                v-if="selectedgroup"
                :items="groups"
                label="Group *"
                :rules="groupsRules"
                item-text="name"
                item-value="id"
                v-model="selectedgroup"
                :disabled="true"
            ></v-autocomplete>

            <v-text-field
                v-model="admin.name"
                :rules="nameRules"
                label="Name *"
                autocomplete="off"
                required
            ></v-text-field>

            <v-text-field
                v-model="admin.email"
                :rules="emailRules"
                label="E-mail *"
                required
                autocomplete="off"
            ></v-text-field>

            <vue-tel-input
                v-model="admin.phone_no"
                name="phone"
                defaultCountry="SG"
                :onlyCountries="['SG', 'MY', 'CN', 'HK']"
                required
                :maxLen="15"
                enabledCountryCode
                validCharactersOnly
                :wrapperClasses="['mobile-input']"
                @validate="validateMobile"
                class="col ml-0"
                autocomplete="off"
            ></vue-tel-input>
            <v-row
                v-if="admin.phone_no.length > 0 && !mobileIsValid"
                justify="center"
                style="margin-top: -18px; margin-bottom: 5px;"
            >
              <v-flex class="col-6 ml-1">
                <span style="font-size: 10px; color: red">Your mobile number is invalid</span>
              </v-flex>
            </v-row>
            <v-row>
              <v-col cols="2">
                <v-btn
                    :disabled="!valid"
                    color="success"
                    class="mr-4 font-weight-bold"
                    @click="submit"
                >
                  Save
                </v-btn>
              </v-col>
              <v-col cols="2">
                <v-btn
                    color="primary"
                    class="font-weight-bold"
                    @click="resetPassword"
                >
                  reset password
                </v-btn>
              </v-col>

            </v-row>
          </v-form>
        </v-col>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from 'axios'

export default {
  data: () => ({
    valid: false,
    groups: [],
    groupsRules: [
      v => !!v || 'Group is required',
    ],
    nameRules: [
      v => !!v || 'Name is required',
    ],

    emailRules: [
      v => !!v || 'E-mail is required',
      v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
    ],
    internationalPhone: '',
    mobileIsValid: false,
    countryCodes: [
      {'flag': '🇸🇬', 'country_code': 65, 'name': 'Singapore'},
      {'flag': '🇨🇳', 'country_code': 86, 'name': 'China'},
      {'flag': '🇭🇰', 'country_code': 852, 'name': 'Hong Kong SAR China'},
      {'flag': '🇲🇾', 'country_code': 60, 'name': 'Malaysia'},
    ],
    breadcrumbsItems: '',
    success: null,
    error: null,
    error_msg: null
  }),
  props: ['admin', 'selectedgroup'],
  computed: {
    maxWidth() {
      return {
        maxWidth: window.outerWidth + 'px'
      }
    }
  },
  methods: {
    validateMobile(phoneObject) {
      this.mobileIsValid = phoneObject.valid;
      this.country_code = phoneObject.country_code;
      if (phoneObject.valid && phoneObject.nationalNumber) {
          this.internationalPhone = phoneObject.country.dialCode + phoneObject.nationalNumber
      }
    },
    openMobile() {
      // Manually set using JS because CSS isn't applying the style
      const dropdownElementStyle = document.getElementsByClassName('vti__dropdown')[0].childNodes[2].style;
      if (dropdownElementStyle) {
        dropdownElementStyle.fontSize = "14px";
        dropdownElementStyle.width = "250px";
      }
    },
    submit() {
      if (this.$refs.form.validate()) {
        axios.post('/admin/' + this.admin.id + '/update', {
          name: this.admin.name,
          email: this.admin.email,
          phone_no: this.internationalPhone,
          group_id: this.selectedgroup,
        }).then(response => {
          window.location.href = '/superadmin'
        });
      }
    },
    resetPassword() {
      axios.post('/password/email', {
        email: this.admin.email
      }).then(response => {
          swal({
              title: "We have e-mailed your password reset link!",
              icon: "success",
          })
      }).catch(e => {
          swal({
              title: e,
              icon: "error",
          })
      })
    }
  },
  beforeMount() {
    // get outlets
    axios.get('/api/getGroups').then(response => {
      this.groups = response.data
    });
    this.breadcrumbsItems = [
      {
        disabled: false,
        href: '/',
        link: true,
        text: 'Home',
      },
      {
        disabled: true,
        href: '#',
        link: true,
        text: 'Edit Admin',
      },
    ];
  }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Admins/AdminEdit.vue